import { j as u } from "../../jsx-runtime.BREq8dyb.js";
import { useForkRef as G } from "@decentriq/hooks";
import { Box as I } from "@mui/joy";
import { Transition as J } from "notistack";
import { forwardRef as K, useRef as f } from "react";
import { createTransition as x, reflow as M, getTransitionProps as E } from "../../utils/index.js";
const Q = K((y, w) => {
  const {
    addEndListener: z,
    appear: R,
    children: T,
    collapsedSize: a = 0,
    direction: U,
    // NOTE: Taking it out of the rest as this is a Slide-only prop
    enter: v,
    exit: j,
    in: p,
    mountOnEnter: F,
    onEnter: S,
    onEntered: $,
    onEntering: b,
    onExit: D,
    onExited: H,
    onExiting: P,
    orientation: e,
    timeout: l = 175,
    unmountOnExit: W = !0,
    style: d,
    ...C
  } = y, o = e === "horizontal", r = o ? "width" : "height", s = typeof a == "number" ? `${a}px` : a, n = f(null), m = f(null), O = G(w, m), g = () => n.current ? o ? n.current.clientWidth : n.current.clientHeight : 0, k = (t, i) => {
    n.current && o && (n.current.style.position = "absolute"), t.style[r] = s, S?.(t, i);
  }, B = (t, i) => {
    const h = g();
    n.current && o && (n.current.style.position = "");
    const {
      duration: c = 0,
      easing: A = ""
    } = E({
      mode: "enter",
      style: d,
      timeout: l
    });
    t.style.transitionDuration = typeof c == "string" ? c : `${c}ms`, t.style[r] = `${h}px`, t.style.transitionTimingFunction = A, b?.(t, i);
  }, L = (t, i) => {
    t.style[r] = "auto", $?.(t, i);
  }, N = (t) => {
    t.style[r] = `${g()}px`, D?.(t);
  }, q = (t) => {
    M(t);
    const {
      duration: i = 0,
      easing: h = ""
    } = E({
      mode: "exit",
      timeout: l
    });
    t.style.transitionDuration = typeof i == "string" ? i : `${i}ms`, t.style.height = s, t.style.transitionTimingFunction = h, P?.(t);
  };
  return /* @__PURE__ */ u.jsx(J, { addEndListener: z, appear: R, enter: v, exit: j, in: p, mountOnEnter: F, nodeRef: m, onEnter: k, onEntered: L, onEntering: B, onExit: N, onExited: H, onExiting: q, timeout: l, unmountOnExit: W, children: (t, i) => /* @__PURE__ */ u.jsx(I, { ...C, ref: O, style: {
    height: 0,
    minHeight: s,
    overflow: "hidden",
    pointerEvents: "all",
    transition: x("height"),
    ...e === "horizontal" && {
      height: "auto",
      minHeight: "auto",
      minWidth: s,
      transition: x("width"),
      width: 0
    },
    ...t === "entered" && {
      height: "auto",
      overflow: "visible",
      ...e === "horizontal" && {
        width: "auto"
      }
    },
    ...t === "exited" && !p && {
      visibility: "hidden"
    },
    ...d
  }, ...i, children: /* @__PURE__ */ u.jsx("div", { ref: n, style: {
    display: "flex",
    width: "100%",
    ...e === "horizontal" && {
      height: "100%",
      width: "auto"
    }
  }, children: T }) }) });
});
Q.displayName = "Collapse";
export {
  Q as default
};
//# sourceMappingURL=Collapse.js.map
